/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RequestComment
 */
export interface RequestComment {
    /**
     *
     * @type {string}
     * @memberof RequestComment
     */
    commentId: string;
    /**
     *
     * @type {string}
     * @memberof RequestComment
     */
    author: string;
    /**
     *
     * @type {string}
     * @memberof RequestComment
     */
    timestamp: string;
    /**
     *
     * @type {string}
     * @memberof RequestComment
     */
    content: string;
}

export function RequestCommentFromJSON(json: any): RequestComment {
    return RequestCommentFromJSONTyped(json, false);
}

export function RequestCommentFromJSONTyped(json: any, _: boolean): RequestComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'commentId': json['comment_id'],
        'author': json['author'],
        'timestamp': json['timestamp'],
        'content': json['content'],
    };
}

export function RequestCommentToJSON(value?: RequestComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'comment_id': value.commentId,
        'author': value.author,
        'timestamp': value.timestamp,
        'content': value.content,
    };
}
